export const CONTACT = {
  address: {
    line1: 'Del Río No.5, El Gavillero',
    line2: '54459 Cdad. Nicolás Romero',
    line3: 'Estado de México',
  },
  phone: '56 5371-2507',
  phoneE164: '+525653712507',
  whatsapp: '525653712507',
  email: 'info@laspolvillas.mx',
  emailVentas: 'ventas@laspolvillas.mx',
  emailRH: 'echaparro@laspolvillas.mx',
  // Reclutamiento / Recursos Humanos
  phoneRH: '56 6491 2345',
  phoneRHE164: '+525664912345',
  whatsappRH: '525664912345',
  horario: [
    'Lun – Vie   ·   8:00am – 8:00pm',
    'Sábado   ·   8:00am – 5:00pm',
    'Domingo · Cerrado',
  ],
};

export const TIPOS_CLIENTE = [
  'Restaurante / Taquería',
  'Distribuidor / Mayorista',
  'Carnicería',
  'Cliente final',
  'Otro',
];

export interface Testimonio {
  quote: string;
  nombre: string;
  rol: string;
  stars: number; // 0-5, soporta medios (4.5)
}

export const TESTIMONIOS: Testimonio[] = [
  {
    quote:
      'El Chorizo Especial de Las Polvillas es el mejor que he probado para mis taquizas. Mis clientes siempre me preguntan de dónde lo consigo. Sin duda el proveedor más confiable.',
    nombre: 'Ricardo Hernández',
    rol: 'Dueño de taquería · Ciudad de México',
    stars: 5,
  },
  {
    quote:
      'Llevo 3 años comprando la Espaldilla y el Jamón El Dorado. La calidad es consistente, los precios son justos y el servicio siempre a tiempo. 100% recomendados.',
    nombre: 'Guadalupe Morales',
    rol: 'Distribuidora mayorista · Acapulco',
    stars: 5,
  },
  {
    quote:
      'Encontrar un proveedor tan comprometido con la calidad es difícil. Las Polvillas ha superado mis expectativas desde el primer pedido.',
    nombre: 'Jorge Ramírez',
    rol: 'Cliente · Nicolás Romero, Méx.',
    stars: 4.5,
  },
];

// Imágenes hero/historia desde el CDN del demo (Wix)
export const HERO_IMAGES = {
  pierna:       'https://static.wixstatic.com/media/0a7e2f_ed8f2d1642a64ef293615cbf57397872~mv2.jpg',
  espaldilla:   'https://static.wixstatic.com/media/0a7e2f_1cd3b5f8cb144b64b1f9dd7c70a100b9~mv2.jpg',
  productos:    'https://static.wixstatic.com/media/0a7e2f_e69ba685f9e143e49793a56aed0ad55e~mv2.jpg',
  chorizo:      'https://static.wixstatic.com/media/0a7e2f_00ee0928ce844afb8959ff2363f24b94~mv2.jpg',
};
